/** Step-up ★ : modale déclenchée automatiquement par le client API sur MFA_RECENTE_REQUISE, puis l'appel est rejoué. */
import { useEffect, useRef, useState } from 'react';
import { Alert, Button, Modal, TextField } from '@myron/design-system';
import { brancherReauth, messageErreur, post } from '../../shared/api/client';
import { useSession, type Session } from '../../shared/auth/session';

export function GestionnaireReauthentification() {
  const { session, definir } = useSession();
  const [ouverte, setOuverte] = useState(false);
  const [valeur, setValeur] = useState('');
  const [erreur, setErreur] = useState<unknown>(null);
  const [envoi, setEnvoi] = useState(false);
  const resolveur = useRef<((ok: boolean) => void) | null>(null);
  const mfa = !!session?.utilisateur.mfaActive;

  useEffect(() => {
    brancherReauth(() => new Promise<boolean>((resolve) => {
      resolveur.current = resolve;
      setValeur('');
      setErreur(null);
      setOuverte(true);
    }));
    return () => brancherReauth(null);
  }, []);

  const fermer = (ok: boolean) => {
    setOuverte(false);
    resolveur.current?.(ok);
    resolveur.current = null;
  };
  const valider = async () => {
    setEnvoi(true);
    setErreur(null);
    try {
      const s = await post<Session>('/auth/reauthentification', mfa ? { code: valeur.trim() } : { motDePasse: valeur }, { sansReauth: true });
      definir({ ...s, etape: 'CONNECTE' });
      fermer(true);
    } catch (e) { setErreur(e); } finally { setEnvoi(false); }
  };

  return (
    <Modal
      ouverte={ouverte}
      titre="Confirmez votre identité"
      onFermer={() => fermer(false)}
      actions={<><Button variante="tertiaire" onClick={() => fermer(false)}>Annuler</Button><Button chargement={envoi} disabled={!valeur} onClick={valider}>Confirmer</Button></>}
    >
      <div className="my-pile">
        <p>Cette action est sensible : {mfa ? 'saisissez un code de vérification récent.' : 'saisissez votre mot de passe.'}</p>
        {erreur ? <Alert ton="erreur">{messageErreur(erreur)}</Alert> : null}
        <TextField
          label={mfa ? 'Code à 6 chiffres' : 'Mot de passe'}
          type={mfa ? 'text' : 'password'}
          inputMode={mfa ? 'numeric' : undefined}
          autoComplete={mfa ? 'one-time-code' : 'current-password'}
          value={valeur}
          onChange={(e) => setValeur(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && valeur) void valider(); }}
        />
      </div>
    </Modal>
  );
}
